"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d = require("d3");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var percToDeg = function percToDeg(perc) {
  return perc * 360;
};
var deg2rad = function deg2rad(deg) {
  return deg * Math.PI / 180;
};
var percToRad = function percToRad(perc) {
  return deg2rad(percToDeg(perc));
};

function arcTween(arc, newAngle) {
  return function (d) {
    var interpolate = (0, _d.interpolate)(d.endAngle, newAngle);
    return function (t) {
      d.endAngle = interpolate(t);
      return arc(d);
    };
  };
}

function isStr(obj) {
  return obj && typeof obj === "string";
}

var Gauge = function (_React$Component) {
  _inherits(Gauge, _React$Component);

  function Gauge(props) {
    _classCallCheck(this, Gauge);

    var _this = _possibleConstructorReturn(this, (Gauge.__proto__ || Object.getPrototypeOf(Gauge)).call(this, props));

    _this.render = function () {
      return _react2.default.createElement("div", { ref: function ref(_ref) {
          return _this.gaugeDiv = _ref;
        } });
    };

    _this._d3_refs = {
      powerGauge: false
    };

    _this.resetInitValue();
    return _this;
  }

  _createClass(Gauge, [{
    key: "resetInitValue",
    value: function resetInitValue() {
      this.initialValue = this.props.value || 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderGauge();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this.resetInitValue();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(new_props) {
      this.props = new_props;
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderGauge();
    }
  }, {
    key: "getGauge",
    value: function getGauge() {
      var self = this; // save reference
      var PROPS = this.props;

      return function (container) {
        // default config that are 'not' configurable
        var default_config = {
          minAngle: -90,
          maxAngle: 90,
          parentWidth: self.gaugeDiv.parentNode.clientWidth,
          parentHeight: self.gaugeDiv.parentNode.clientHeight

          // START: Configurable values
        };var config = {
          chartId: PROPS.chartId,
          width: PROPS.fluidWidth ? default_config.parentWidth : PROPS.width,
          height: PROPS.fluidWidth ? default_config.parentHeight : PROPS.height,
          // ring width should be 1/4 th of width
          ringWidth: PROPS.ringWidth,
          ringInset: PROPS.ringInset,
          // min/max values
          value: PROPS.value,
          // color of the speedometer needle
          needleColor: PROPS.needleColor,
          needleWidth: PROPS.needleWidth,
          // segments in the speedometer
          segments: PROPS.segments,
          segmentsColors: PROPS.segmentsColors,
          segmentGap: PROPS.segmentGap,
          barLabels: PROPS.barLabels,
          labelsLocations: PROPS.labelsLocations,
          gradientChange: PROPS.gradientChange,
          // needle configuration
          needleTransition: PROPS.needleTransition,
          needleTransitionDuration: PROPS.needleTransitionDuration,
          needleTransitionDelay: PROPS.needleTransitionDelay,
          needleHeightRatio: PROPS.needleHeightRatio,
          // text color
          labelsColor: PROPS.labelsColor
        };
        // END: Configurable values

        // merge default config with the config
        config = Object.assign({}, default_config, config);

        var range = null,
            r = null,
            needleLength = null,
            svg = null,
            arc = null;

        function configure() {
          range = config.maxAngle - config.minAngle;
          r = Math.min(config.width, config.height * 2) / 2;

          needleLength = (0, _utils.calculateNeedleHeight)(config.needleHeightRatio, r);

          arc = (0, _d.arc)().innerRadius(r - config.ringWidth - config.ringInset).outerRadius(r - config.ringInset).padAngle(config.segmentGap);
        }

        function render(newValue) {
          svg = (0, _d.select)(container).append("svg:svg").attr("class", "speedometer").attr("width", config.width).attr("height", config.height);

          var centerTx = "translate(" + r + "," + r + ")";

          var arcs = svg.append("g").attr("class", "arc").attr("transform", centerTx);

          if (config.gradientChange) {
            var _arc = (0, _d.arc)().innerRadius(r - config.ringWidth - config.ringInset).outerRadius(r - config.ringInset).startAngle(-0.5 * Math.PI);

            arcs.append("path").datum({ endAngle: 0.5 * Math.PI }).style("fill", "#F5F5F5").attr("d", _arc);

            var foreground = arcs.append("path").style("fill", function () {
              var colors = config.segmentsColors[0];
              colors = isStr(colors) ? [colors] : colors;
              var defs = arcs.append('defs');
              var linearGradient = defs.append('linearGradient').attr('id', 'section-color-' + config.chartId).attr('x1', '0%').attr('y1', '100%').attr('x2', '100%').attr('y2', '0%');

              linearGradient.append('stop').attr('offset', '0%').attr('style', 'stop-color:' + colors[0] + ';stop-opacity:1');

              linearGradient.append('stop').attr('offset', '100%').attr('style', 'stop-color:' + colors[1] + ';stop-opacity:1');

              return 'url(' + '#section-color-' + config.chartId + ')';
            }).datum({ endAngle: -0.5 * Math.PI }).attr("d", _arc);

            foreground.transition().delay(config.needleTransitionDelay).duration(config.needleTransitionDuration).attrTween("d", arcTween(_arc, (newValue - 0.5) * Math.PI));
          } else {
            var arcData = [];
            var totalPercent = config.minAngle;
            for (var index = 0; index < config.segments.length; ++index) {
              var segmentPercentage = config.segments[index] * range;

              var startAngle = totalPercent;
              var endAgnle = startAngle + segmentPercentage;
              arcData[index] = {
                startAngle: deg2rad(startAngle),
                endAngle: deg2rad(endAgnle)
              };
              totalPercent += segmentPercentage;
            }

            arcs.selectAll("path").data(arcData).enter().append("path").attr("class", "speedo-segment").style("fill", function (d, i) {
              var colors = config.segmentsColors[i];

              if (isStr(colors)) {
                return [colors];
              } else if (colors.length <= 1) {
                return colors;
              } else {
                var defs = svg.append('defs');
                var linearGradient = defs.append('linearGradient').attr('id', 'section-color-' + config.chartId).attr('x1', '0%').attr('y1', '100%').attr('x2', '100%').attr('y2', '0%');
                linearGradient.append('stop').attr('offset', '0%').attr('style', 'stop-color:' + colors[0] + ';stop-opacity:1');
                linearGradient.append('stop').attr('offset', '100%').attr('style', 'stop-color:' + colors[1] + ';stop-opacity:1');

                return 'url(' + '#section-color-' + config.chartId + ')';
              }
            }).attr("d", arc);
          }

          /*
            Set the location of the labels of the guage
          */
          if (config.barLabels) {
            var locations = config.labelsLocations;
            config.barLabels.forEach(function (o, p) {
              var labelX = void 0;
              var labelY = void 0;
              if (locations && locations.length > 0) {
                labelX = locations[p][0];
                labelY = locations[p][1];
              } else {
                labelX = 0;
                labelY = 0;
              }
              arcs.append('text').attr('x', labelX).attr('y', labelY).attr('fill', config.labelsColor).attr('style', 'font-size:12px;').html(config.barLabels[p]);
            });
          }

          function _getRotate(percent) {
            var halfPI = Math.PI / 2;
            var thetaRad = percToRad(percent / 2);
            var rotate = (thetaRad - halfPI) * 180 / Math.PI;

            return 'rotate(' + rotate + ')';
          }

          var pg = svg.append("g").attr("class", "pointer").attr("transform", centerTx).style("fill", config.needleColor);

          self._d3_refs.pointer = pg.append("path").attr("d", 'M ' + -1 * config.needleWidth + ' ' + 0 + ' L ' + config.needleWidth + ' ' + 0 + ' L ' + config.needleWidth / 2 + ' ' + -1 * needleLength + ' L ' + -1 * config.needleWidth / 2 + ' ' + -1 * needleLength).attr("transform", "rotate(" + config.minAngle + ")").transition().delay(config.needleTransitionDelay);

          if (!config.gradientChange) {
            self._d3_refs.pointer.ease(self.getTransitionMethod(config.needleTransition));
          }

          self._d3_refs.pointer.duration(config.needleTransitionDuration).attr('transform', _getRotate(config.value));
        }

        configure();

        // return a object with all our functions;
        // also expose the 'config' object; for now, we will update the 'labelFormat' while updating
        return {
          configure: configure,
          render: render,
          config: config
        };
      };
    }
  }, {
    key: "renderGauge",
    value: function renderGauge() {
      (0, _d.select)(this.gaugeDiv).select("svg").remove();

      this._d3_refs.powerGauge = this.getGauge()(this.gaugeDiv);
      this._d3_refs.powerGauge.render(this.initialValue);
    }
  }, {
    key: "getTransitionMethod",
    value: function getTransitionMethod(transition) {
      switch (transition) {
        case "easeLinear":
          return _d.easeLinear;
        case "easeQuadIn":
          return _d.easeQuadIn;
        case "easeQuadOut":
          return _d.easeQuadOut;
        case "easeQuadInOut":
          return _d.easeQuadInOut;
        case "easeCubicIn":
          return _d.easeCubicIn;
        case "easeCubicOut":
          return _d.easeCubicOut;
        case "easeCubicInOut":
          return _d.easeCubicInOut;
        case "easePolyIn":
          return _d.easePolyIn;
        case "easePolyOut":
          return _d.easePolyOut;
        case "easePolyInOut":
          return _d.easePolyInOut;
        case "easeSinIn":
          return _d.easeSinIn;
        case "easeSinOut":
          return _d.easeSinOut;
        case "easeSinInOut":
          return _d.easeSinInOut;
        case "easeExpIn":
          return _d.easeExpIn;
        case "easeExpOut":
          return _d.easeExpOut;
        case "easeExpInOut":
          return _d.easeExpInOut;
        case "easeCircleIn":
          return _d.easeCircleIn;
        case "easeCircleOut":
          return _d.easeCircleOut;
        case "easeCircleInOut":
          return _d.easeCircleInOut;
        case "easeBounceIn":
          return _d.easeBounceIn;
        case "easeBounceOut":
          return _d.easeBounceOut;
        case "easeBounceInOut":
          return _d.easeBounceInOut;
        case "easeBackIn":
          return _d.easeBackIn;
        case "easeBackOut":
          return _d.easeBackOut;
        case "easeBackInOut":
          return _d.easeBackInOut;
        case "easeElasticIn":
          return _d.easeElasticIn;
        case "easeElasticOut":
          return _d.easeElasticOut;
        case "easeElasticInOut":
          return _d.easeElasticInOut;
        case "easeElastic":
          return _d.easeElastic;
        default:
          return _d.easeQuadInOut;
      }
    }
  }]);

  return Gauge;
}(_react2.default.Component);

Gauge.displayName = "Gauge";


Gauge.propTypes = {
  chartId: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  fluidWidth: _propTypes2.default.bool.isRequired,
  segments: _propTypes2.default.array.isRequired,
  segmentsColors: _propTypes2.default.array.isRequired,
  segmentGap: _propTypes2.default.number.isRequired,
  barLabels: _propTypes2.default.array.isRequired,
  labelsLocations: _propTypes2.default.array.isRequired,
  needleColor: _propTypes2.default.string.isRequired,
  needleTransition: _propTypes2.default.string.isRequired,
  needleTransitionDuration: _propTypes2.default.number.isRequired,
  needleHeightRatio: _propTypes2.default.number.isRequired,
  ringWidth: _propTypes2.default.number.isRequired,
  ringInset: _propTypes2.default.number.isRequired,
  labelsColor: _propTypes2.default.string.isRequired,
  gradientChange: _propTypes2.default.bool.isRequired

  // define the default proptypes
};Gauge.defaultProps = {
  chartId: '',
  value: 0,
  segmentGap: 0,
  width: 120,
  height: 80,
  fluidWidth: false,
  segments: [],
  segmentsColors: [['#C62B12'], ['#DD8075'], ['#7ED2FB'], ['#25B4F8']],
  barLabels: [],
  labelsLocations: [['-47', '15'], ['32', '15']],
  needleWidth: 3.5,
  needleColor: "#202020",
  gradientChange: false,
  needleHeightRatio: 0.9,
  ringWidth: 12,
  ringInset: 0,
  labelsColor: "#666",
  needleTransition: "easeQuadInOut",
  needleTransitionDuration: 3000,
  needleTransitionDelay: 0
};

exports.default = Gauge;